module.exports = __webpack_public_path__ + "static/media/image001.1b815513.png";